import regAside from '@/assets/images/reg-aside.jpg';

const wregPhotoModules = import.meta.glob<{ default: string }>('@/assets/images/wreg/*.jpg', {
  eager: true,
});

const photoByName: Record<string, string> = Object.fromEntries(
  Object.entries(wregPhotoModules).map(([path, mod]) => [path.split('/').pop() as string, mod.default]),
);

const photo = (name: string): string | null => photoByName[name] ?? null;

export const WREG_ORDER = [
  'intake',
  'screener',
  'tracks',
  'agreement',
  'switch',
  'labs',
  'monitor',
  'allset',
  'x-notelig',
  'x-already',
  'x-control',
  'x-mismatch',
  'x-noqualify',
  'x-error',
  'x-switchok',
  'x-outreach',
  'x-labspending',
  'x-declined',
] as const;

export type WregStep = (typeof WREG_ORDER)[number];

export type WregGroup = 'intake' | 'care' | 'labs' | 'app' | 'exception';

export const WREG_TOTAL_STEPS = 5;

export const WREG_WORKING_MS = 1500;

export const WREG_GROUP: Partial<Record<WregStep, WregGroup>> = {
  intake: 'intake',
  screener: 'care',
  tracks: 'care',
  agreement: 'care',
  switch: 'care',
  labs: 'labs',
  monitor: 'app',
  allset: 'app',
};

export const wregGroup = (step: WregStep): WregGroup => WREG_GROUP[step] ?? 'exception';

export const WREG_ASIDE: Record<WregGroup, string> = {
  intake: 'wreg.aside.intake',
  care: 'wreg.aside.care',
  labs: 'wreg.aside.labs',
  app: 'wreg.aside.app',
  exception: 'wreg.aside.exception',
};

export const PHOTO_FILE: Partial<Record<WregStep, string>> = {
  intake: 'reg-aside.jpg',
  screener: 'wreg-step-2.jpg',
  tracks: 'wreg-step-2.jpg',
  agreement: 'wreg-step-3.jpg',
  switch: 'wreg-step-3.jpg',
  labs: 'wreg-step-4.jpg',
  monitor: 'wreg-aside-monitor.jpg',
  allset: 'wreg-step-6.jpg',
};

export const WREG_PHOTOS: Partial<Record<WregStep, string>> = Object.fromEntries(
  (Object.keys(PHOTO_FILE) as WregStep[])
    .map((step) => [step, step === 'intake' ? regAside : photo(PHOTO_FILE[step] as string)])
    .filter(([, url]) => url !== null),
);

export const WREG_PHOTO_LIST: string[] = [
  ...new Set(Object.values(WREG_PHOTOS) as string[]),
];

export const wregPhoto = (step: WregStep): string => WREG_PHOTOS[step] ?? regAside;

const WREG_STEP_NUMBER: Partial<Record<WregStep, number>> = {
  intake: 1,
  screener: 2,
  tracks: 2,
  agreement: 2,
  switch: 2,
  labs: 3,
  monitor: 4,
  allset: 5,
};

export const wregStepNumber = (step: WregStep): number | null => WREG_STEP_NUMBER[step] ?? null;
